import React from "react";
import styled from "styled-components";
import { Button } from "antd";

/**
 * AvailabilityTimePickerCard
 * Renders a set of time slot buttons inside the chat stream.
 *
 * Expected `slots` format (flexible):
 * - [{ id?, label?, start?, startTime?, startISO?, display?, iso? }]
 */
const AvailabilityTimePickerCard = ({
  title = "Pick a tour time",
  slots = [],
  onSelect,
  disabled,
}) => {
  const normalized = (Array.isArray(slots) ? slots : [])
    .map((s, idx) => {
      const iso =
        s?.startISO ||
        s?.startTime ||
        s?.start ||
        s?.iso ||
        s?.datetime ||
        null;
      const label =
        s?.label ||
        s?.display ||
        s?.timeLabel ||
        (iso ? new Date(iso).toLocaleString() : `Slot ${idx + 1}`);
      return {
        id: s?.id || `${idx}`,
        iso,
        label,
        raw: s,
      };
    })
    .filter((s) => s.label);

  return (
    <Card>
      <CardTitle>{title}</CardTitle>
      {normalized.length === 0 ? (
        <EmptyText>No times available right now. Try again in a bit.</EmptyText>
      ) : (
        <SlotsGrid>
          {normalized.map((slot) => (
            <SlotButton
              key={slot.id}
              onClick={() => onSelect?.(slot)}
              disabled={disabled}
            >
              {slot.label}
            </SlotButton>
          ))}
        </SlotsGrid>
      )}
    </Card>
  );
};

export default AvailabilityTimePickerCard;

const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(44, 95, 45, 0.15);
  border-radius: 12px;
  padding: 12px;
`;

const CardTitle = styled.div`
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--color-text);
  margin-bottom: 10px;
`;

const EmptyText = styled.div`
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  line-height: 1.35;
`;

const SlotsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
`;

const SlotButton = styled(Button)`
  width: 100%;
  text-align: left;
  height: auto;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(44, 95, 45, 0.18) !important;
  color: var(--color-primary-dark) !important;
  font-weight: 600;
  background: rgba(44, 95, 45, 0.04) !important;

  &:hover:not(:disabled) {
    border-color: rgba(44, 95, 45, 0.35) !important;
    background: rgba(44, 95, 45, 0.08) !important;
    color: var(--color-primary-dark) !important;
  }
`;
